import * as PIXI from "pixi.js";


export default class PlayerLeftNotification extends PIXI.Container
{
    public constructor( username: string )
    {
        super();

        let bg: PIXI.Graphics = new PIXI.Graphics();
        bg.beginFill( 0x323c6a, 0.9 );
        const kHalfWidth: number = 176 * 2/3;
        const kHalfHeight: number = 80 * 2/3;
        bg.drawRoundedRect( -kHalfWidth, -kHalfHeight, kHalfWidth * 2, kHalfHeight * 2, 30 );
        bg.endFill();
        this.addChild( bg );

        let text: PIXI.Text = new PIXI.Text( username + "\nleft the game", { fontFamily: "asap_regular", fontSize: 40 * 2/3, fill: 0xffffdf, align: "center" } );
        text.anchor.set( 0.5 );
        this.addChild( text );
    }
}
